/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 帮助中心
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export default async function (
  documentsId: string,

  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: Array<cms.ShopHelpCenterDto>;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "get",
    url: `/cms/shop/help-center/${documentsId}`,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
